// extracted by mini-css-extract-plugin
export default {"road":"Map_road__Jr8wS","text":"Map_text__AC1Xh","pin":"Map_pin__Z0Ist","pinLabel":"Map_pinLabel__r64N8"};